import AppPath from "../../../components/App/models/AppPath";
import FeatureName from "../../../components/App/models/FeatureName";

class RCRAPath extends AppPath {
  public static readonly RCRA = new AppPath({
    id: "rcra",
    label: "RCRA Student Form",
    path: "/rcra/:id?/:approvals?/:token?",
    featureName: FeatureName.RCRAMinors,
  });

  public static readonly RCRASuccess = new AppPath({
    id: "rcraSuccess",
    label: "Success Page",
    path: "/rcra-success",
  });
}
export default RCRAPath;
